import {Component} from "@angular/core";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {PrestFiltre,TypeFiltreChar} from "@domain/prestation/prest-filtre";

/**
 * Composant d'affichage d'un filtre dans la liste des filtres disponibles
 */
@Component({
    host: {'data-test-id': 'ajout-filtre-item'},
    selector: 'ajout-filtre-item',
    templateUrl: './ajout-filtre-item.component.html'
})
export class AjoutFiltreItemComponent extends ListViewItem<PrestFiltre> {
    /** Types de filtres possibles */
    protected readonly TypeFiltreChar = TypeFiltreChar;

    /**
     * Méthode appelée lorsque l'utilisateur sélectionne le filtre affiché
     */
    onSelect() {
        //Emission de l'événement vers le composant parent pour indiquer que ce filtre a été choisi
        this.extraOptions.selectEvent(this.data);
    }
}